export default function (http) {
    return {

        saveOrtherFee (data){
            return http.json({
                url: `/erp/rep/fix/saveOrtherFee`,
                data
            })
        },


        saveRepItemInfo (data){
            return http.json({
                url: `/erp/rep/fix/item/save`,
                data
            })
        },


        saveInfo (data){
            return http.json({
                url: `/erp/rep/fix/save`,
                data
            })
        },


        pass(data) {
            return http.json({
                url: `/erp/rep/fix/passRepFix`,
                data
            })
        },
        cwAudit(data) {
            return http.json({
                url: `/erp/rep/fix/cwAudit`,
                data
            })
        },

        fail(data) {
            return http.json({
                url: `/erp/rep/fix/failRepFix`,
                data
            })
        },



        queryPassList(data) {
            return http.json({
                url: `/erp/rep/fix/queryPassList`,
                data
            })
        },



        queryAll(data) {
            return http.json({
                url: `/erp/rep/fix/queryAll`,
                data
            })
        },



        deleteRepItem (data){
            return http.json({
                url: `/erp/rep/fix/item/deleteRepItem`,
                data
            })
        },
        queryByPage(data) {
            return http.json({
                url: `/erp/rep/fix/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/erp/rep/fix/get?id=${data.id}`,
                data
            })
        },

        getItemInfo(data){
            return http.json({
                url: `/erp/rep/fix/item/get?id=${data.id}`,
                data
            })
        },

        updateItemPrice(data){
            return http.json({
                url: '/erp/rep/fix/item/updateItemPrice',
                data
            });
        },

        query(data) {
            return http.json({
                url: `/erp/rep/fix/queryByPage?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryItems(data) {
            return http.json({
                url: `/erp/rep/fix/queryItems?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryDistinctServiceOrderId(data) {
            return http.json({
                url: `/erp/rep/fix/queryDistinctServiceOrderId`,
                data
            });
        },



        queryRepFixByServiceOrderId(data) {
            return http.json({
                url: `/erp/rep/fix/queryRepFixByServiceOrderId`,
                data
            });
        },

        terminate(data) {
            return http.json({
                url: `/order/base/terminate`,
                data
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/repFix.js